<template>
    <div class="flex flex-col items-center">
        <div class="flex flex-wrap mb-3">
            <div class="w-1/2 md:w-4/12 flex flex-col">
                <span class="text-theme-primary"> Costo actual </span>
                <span>{{ costInitial | money }}</span>
            </div>
            <div class="w-1/2 md:w-4/12 flex flex-col">
                <span class="text-theme-primary"> Margen actual </span>
                <span>{{ revenueCurrent | percent }}</span>
            </div>
            <div class="w-1/2 md:w-4/12 flex flex-col">
                <span class="text-theme-primary"> Precio u. actual </span>
                <span> {{ priceOffer | money }}</span>
            </div>
            <div v-show="costTemp" class="w-1/2 md:w-4/12 flex flex-col">
                <span class="text-theme-primary"> {{ messageCost }} </span>
                <span>{{ messageValue }}</span>
            </div>
            <div v-show="costTemp" class="w-1/2 md:w-4/12 flex flex-col">
                <span class="text-theme-primary"> Margen bruto </span>
                <span
                    :class="{
                        'text-theme-primary': revenue > 0.3,
                        'text-danger': revenue < 0.08
                    }"
                >
                    {{ revenue | percent }}
                </span>
            </div>
        </div>
        <div class="w-full mt-3 flex items-end">
            <div class="w-full">
                <input-money-component
                    v-model="costTemp"
                    enabled
                    :label="
                        isInputCostUnit ? 'Costo de unidad' : 'Costo de lote'
                    "
                    class="w-full min-w-full"
                    @blur="calculateUnitCost"
                />
                <p v-if="costWarning" class="mt-1 text-xs text-theme-warning">
                    {{ costWarning }}
                </p>
            </div>

            <custom-tooltip>
                <app-button
                    icon
                    border
                    :active="isInputCostUnit"
                    @click="updateUnitCostSw"
                >
                    {{ isInputCostUnit ? "1️⃣" : "🔢" }}
                </app-button>
                <template #tooltip>
                    <div class="content-tooltip">
                        <span v-if="isInputCostUnit">
                            Registrar con costo de lote
                        </span>
                        <span v-else>Registrar con costo de unidad</span>
                    </div>
                </template>
            </custom-tooltip>
        </div>
        <div class="w-full mt-8">
            <custom-input
                v-model="inventoryComponent.quantity"
                type="number"
                min="1"
                label="Cantidad"
                @input="calculateUnitCost"
                @blur="calculateUnitCost"
            />
        </div>
        <div class="w-full mt-4 flex justify-center">
            <app-button @click="createInventoryInput">
                Registrar inventario
            </app-button>
        </div>
    </div>
</template>

<script>
import { getCostWarning } from "@/common/lib/price-offer";

import CustomInput from "@/components/utils/CustomInput.vue";
import InputMoneyComponent from "@/components/utils/InputMoneyComponent.vue";

export default {
    name: "InventoryByReference",
    components: { InputMoneyComponent, CustomInput },
    props: {
        costInitial: {
            default: () => 0,
            type: Number,
            required: false
        },
        priceOffer: {
            default: () => 1,
            type: Number,
            required: false
        }
    },
    data: () => ({
        inventoryComponent: {
            costNew: 1000,
            quantity: 1
        },
        costTemp: 0,
        revenue: 0,
        revenueCurrent: 0,
        isInputCostUnit: true,
        messageCost: "Costo de lote",
        messageValue: 0
    }),
    computed: {
        costWarning() {
            return getCostWarning({
                salePrice: this.priceOffer,
                cost: this.inventoryComponent.costNew,
                offerActive: false
            });
        }
    },
    mounted() {
        const costNew = this.costTempInitial || this.priceOffer * 0.7;
        this.costTemp = +costNew;
        this.messageValue = this.$options.filters.money(costNew);
        this.inventoryComponent.costNew = +costNew;
        this.revenueCurrent = 1 - costNew / this.priceOffer;
        this.revenue = +this.revenueCurrent;
    },
    methods: {
        updateUnitCostSw() {
            if (this.isInputCostUnit) {
                this.costTemp =
                    this.costTemp * this.inventoryComponent.quantity;
            } else {
                this.costTemp =
                    this.costTemp / this.inventoryComponent.quantity;
            }
            this.isInputCostUnit = !this.isInputCostUnit;
            this.calculateUnitCost();
        },
        calculateUnitCost() {
            let costUnit = 0;
            if (this.isInputCostUnit) {
                costUnit = +this.costTemp;
                this.inventoryComponent.costNew = +costUnit;
                this.messageCost = `Costo de lote`;
                this.messageValue = this.$options.filters.money(
                    costUnit * this.inventoryComponent.quantity
                );
            } else {
                costUnit = this.costTemp / this.inventoryComponent.quantity;
                this.inventoryComponent.costNew = +costUnit;
                this.messageCost = `Costo de unidad`;
                this.messageValue = this.$options.filters.money(costUnit);
            }
            this.revenue = 1 - costUnit / this.priceOffer;
        },
        createInventoryInput() {
            this.$emit("create", {
                costNew: parseInt(this.inventoryComponent.costNew) || 0,
                quantity: parseInt(this.inventoryComponent.quantity)
            });
        }
    }
};
</script>
